import React from "react";

import {Grid} from "@material-ui/core";
import dateFormat from "dateformat";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from "date-fns/locale/es";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {StaticDatePicker} from '@mui/x-date-pickers/StaticDatePicker';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';
import NextPlanIcon from '@mui/icons-material/NextPlan';
import service from '../../../../plas/services/residues/service';
import alerter from "../../../alerts/alerter"
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import AppointmentItem from "./appointment-item";
import DialogContent from "@mui/material/DialogContent";
import AppointmentForm from "./form";
import {useMediaQuery} from "react-responsive";
import {Appointment, CommunicationChannel} from "../../../../plas/services/residues/models";

export default function Appointments({fullWidth}) {

    const theme = createTheme({
        palette: {
            primary: {
                main: '#FFFFFF', darker: '#FFFFFF',
            }
        },
    });

    const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

    const [date, setDate] = React.useState(new Date(new Date().toDateString()));
    const [showDatePicker, setShowDatePicker] = React.useState(false);
    const [selectedState, setSelectedState] = React.useState(0);
    const [openForm, setOpenForm] = React.useState(false);
    const [appointment, setAppointment] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [appointments, setAppointments] = React.useState({"pending": [], "planned": [], "completed": []});
    const [zones, setZones] = React.useState([]);
    const [residueTypes, setResidueTypes] = React.useState([]);

    React.useEffect(() => {
        loadDashboard(date)
    }, []);


    const refresh = () => {
        loadDashboard(date);
    }

    const loadDashboard = (date) => {
        setLoading(true);
        service.api.dashboard.get(date, (response) => {
            if (response.error != null) {
                alerter.showError(response.error);
            } else {
                response.result.appointments.forEach((appointment) => {
                    appointment.location.zone = response.result.zones.find((zone) => zone.id === appointment.location.zone.id)
                })
                setAppointments({
                    "pending": response.result.appointments.filter((item) => item.state === 'CREATED'),
                    "planned": response.result.appointments.filter((item) => item.state === 'CONFIRMED'),
                    "completed": response.result.appointments.filter((item) => item.state !== 'CREATED' && item.state !== 'CONFIRMED')
                });
                setZones(response.result.zones);
                setResidueTypes(response.result.residueTypes);
            }
            setLoading(false);
        })

    }

    const selectDayView = (chipOption) => {

        if (selectedState !== chipOption) {
            setSelectedState(chipOption);

            let newDate = new Date(new Date().toDateString());
            if (chipOption === 1) {
                newDate.setDate(newDate.getDate() + 1);
            }

            setDate(newDate);
            loadDashboard(newDate);
        }
    }

    const selectDay = (newDate) => {

        setShowDatePicker(false);

        if (newDate === date) return

        let today = new Date(new Date().toDateString());
        if (newDate.getTime() === today.getTime()) {
            selectDayView(0);
            return;
        }

        today.setDate(today.getDate() + 1);
        if (newDate.getTime() === today.getTime()) {
            selectDayView(1);
            return;
        }

        setDate(newDate);
        setSelectedState(2);
        loadDashboard(newDate);
    }

    const select = (appointment) => {
        setAppointment(appointment);
        setOpenForm(true);
    }

    const close = () => {
        setAppointment(null);
        setOpenForm(false);
    }

    const changeSearch = () => {

    }

    const create = () => {
        let appointment = new Appointment()
        appointment.communicationChannel = CommunicationChannel.OFFICE
        appointment.setDate(date)
        setAppointment(appointment);
        setOpenForm(true);
    }

    const onSave = () => {
        alerter.showSuccess("Exito!!");

    }

    const ColoredLine = ({color, marginTop, marginBottom}) => (<hr
        style={{
            color: color,
            backgroundColor: color,
            marginTop: marginTop !== undefined ? marginTop : 6,
            marginBottom: marginBottom !== undefined ? marginBottom : 16,
            height: 2
        }}
    />);

    return (<div>
        <Grid container spacing={2}>
            <Grid item xs={false} md={fullWidth ? false : 2}/>
            <Grid item xs={12} md={fullWidth ? 12 : 8}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={true}>
                                <p style={{fontSize: '28px', textAlign: 'left'}}>
                                    Turnos
                                </p>
                            </Grid>
                            <Grid item>
                                <ThemeProvider theme={theme}>
                                    <Button
                                        startIcon={<AddRoundedIcon/>}
                                        variant="contained"
                                        onClick={create}>
                                        <b>Nuevo turno</b>
                                    </Button>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                        <ColoredLine color="gray" marginTop={0} marginBottom={0}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={true}>
                                <TextField
                                    label="Buscar"
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    onChange={changeSearch}/>
                            </Grid>
                            <Grid item>
                                <Box
                                    style={{"width": 30}}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    {loading ? (<CircularProgress size={20}/>) : (
                                        <IconButton onClick={() => refresh()} color="primary"
                                                    aria-label="refresh" component="label" size="small">
                                            <RefreshIcon/>
                                        </IconButton>)}
                                </Box>
                            </Grid>
                            <Grid item xs={false} sm={2}>
                            </Grid>
                            <Grid item>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    <Stack direction="row" spacing={1}>
                                        <Chip color="default" icon={<EventIcon/>} label="Hoy" component="a"
                                              clickable variant={selectedState === 0 ? "filled" : "outlined"}
                                              onClick={() => selectDayView(0)}/>
                                        <Chip color="default" icon={<NextPlanIcon/>} label="Mañana" component="a"
                                              clickable variant={selectedState === 1 ? "filled" : "outlined"}
                                              onClick={() => selectDayView(1)}/>
                                        <Chip color="default" icon={<CalendarMonthIcon/>} clickable
                                              label={dateFormat(date, "dd/mm/yyyy")}
                                              variant={selectedState === 2 ? "filled" : "outlined"}
                                              onClick={() => setShowDatePicker(true)}/>
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item>
                                    <span style={{fontSize: 24, textAlign: 'left'}}>
                                        Pendientes
                                    </span>
                            </Grid>
                        </Grid>
                        <ColoredLine color="gray" marginTop={4} marginBottom={0}/>
                    </Grid>
                    <Grid item xs={12}>
                        {appointments.pending.map((item) => (<AppointmentItem appointment={item} select={select}/>))}
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item>
                                    <span style={{fontSize: 24, textAlign: 'left'}}>
                                        Planificados
                                    </span>
                            </Grid>
                        </Grid>
                        <ColoredLine color="gray" marginTop={4} marginBottom={0}/>
                    </Grid>
                    <Grid item xs={12}>
                        {appointments.planned.map((item) => (<AppointmentItem appointment={item} select={select}/>))}
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item>
                                    <span style={{fontSize: 24, textAlign: 'left'}}>
                                        Finalizados
                                    </span>
                            </Grid>
                        </Grid>
                        <ColoredLine color="gray" marginTop={4} marginBottom={0}/>
                    </Grid>
                    <Grid item xs={12}>
                        {appointments.completed.map((item) => (<AppointmentItem appointment={item} select={select}/>))}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={false} md={fullWidth ? false : 2}/>
        </Grid>

        <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)} aria-labelledby="form-dialog-title">
            <LocalizationProvider
                adapterLocale={esLocale}
                localeText={{
                    okButtonLabel: "Ok", cancelButtonLabel: "Cancelar"
                }}
                dateAdapter={AdapterDateFns}>
                <StaticDatePicker
                    open={false}
                    componentsProps={{
                        actionBar: {
                            actions: []
                        }
                    }}
                    disabled={false}
                    label={dateFormat(date, "dd/mm/yyyy")}
                    value={date}
                    onChange={selectDay}
                    renderInput={(params) => <TextField
                        {...params}
                        required
                        label="Lugar"
                    />}
                />
            </LocalizationProvider>
        </Dialog>

        <Dialog open={openForm} fullWidth maxWidth="lg" fullScreen={isMedium}>
            <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
                <AppointmentForm fullWidth initialAppointment={appointment} zones={zones} residueTypes={residueTypes.map((item) => { return {"label": item.name, ...item}} )} onCancel={close} onSave={onSave} />
            </DialogContent>
        </Dialog>

    </div>)

}